import React, { useState, useEffect } from 'react';
import './Nav.css';
import logo from '../Images/litax_logo.png';
import { Navbar, Nav, Container, NavDropdown } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { FaBars } from 'react-icons/fa';

const MyNavbar = () => {
  const location = useLocation();
  const [showDropdown, setShowDropdown] = useState(false);

  useEffect(() => {
    const sectionId = location.hash;
    if (sectionId) {
      const sectionElement = document.querySelector(sectionId);
      if (sectionElement) {
        sectionElement.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);

  const isActive = (path) => {
    return location.pathname === path ? 'active-nav-item' : '';
  };

  return (
    <header className="nav-wrapper">
      {/* 🔽 Main Navigation Bar */}
      <Navbar expand="lg" className="custom-navbar">
      <Container fluid>

          <Link to="/" style={{ textDecoration: 'none' }}>
            <Navbar.Brand className="d-flex align-items-center">
             
              <div className="custom-brand-text">
                <img src={logo} alt="Logo" className="custom-logo-img" />
                <p className="custom-tagline">WE FILE TAX , YOU RELAX</p>
              </div>
            </Navbar.Brand>
          </Link>

          {/* Custom toggle button */}
          <Navbar.Toggle aria-controls="basic-navbar-nav" className="custom-toggler">
            <FaBars size={22} color="#25D366" />
          </Navbar.Toggle>

          <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">
            <Nav className="custom-nav-links">
              <Link to="/" className={`custom-nav-item ${isActive('/')}`}>Home</Link>
              <Link to="/aboutus" className={`custom-nav-item ${isActive('/aboutus')}`}>About Us</Link>
<Link to="/services" className={`custom-nav-item ${isActive('/services')}`}>Services</Link>


             

              <Link to="/referandearn" className={`custom-nav-item ${isActive('/referandearn')}`}>Refer & Earn</Link>
              <Link to="/price" className={`custom-nav-item ${isActive('/price')}`}>Pricing</Link>
              <Link to="/refundstatus" className={`custom-nav-item ${isActive('/refundstatus')}`}>Refund Status</Link>
              <Link to="/contact" className={`custom-nav-item ${isActive('/contact')}`}>Contact Us</Link>

              {/* 👉 Register & Login Buttons */}
              <div className="auth-buttons">
                <Link to="/signup" className="btn-auth register-btn">Register</Link>
                <Link to="/login" className="btn-auth login-btn">Login</Link>
              </div>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
};

export default MyNavbar;


